export default __webpack_public_path__ + "static/media/CPD.3b3186bb.png";